import React, {FC, ReactElement} from 'react';
import './index.scss';
import ArrowIcon from './arrow.svg';
import {Popover} from "antd";
import {convertToArray, getLinkRow} from "mixins/helpers";

const ServiceListItem: FC = ({config, url}) => {
    const getLinks = (links: any[]): ReactElement => {
        let node = null;

        links.forEach(x => {
            node = getLinkRow(x.title, x.link, node)
        });

        return node;
    };

    return (
        config.links ? (
            <Popover placement="bottomRight" content={getLinks(convertToArray(config.links))}>
                <div className="service-list-link">
                    <div>
                        { config.name }
                        { config.preview && (
                            <div className="secondary-text mt-1">
                                { config.preview }
                            </div>
                        ) }
                    </div>

                    <div>
                        <ArrowIcon />
                    </div>
                </div>
            </Popover>
        ) : (
            <a className="service-list-link" href={ url } target={config.isExternal ? '_blank' : '_self'}>
                <div>
                    { config.name }
                    { config.preview && (
                        <div className="secondary-text mt-1">
                            { config.preview }
                        </div>
                    ) }
                </div>

                <div>
                    <ArrowIcon />
                </div>
            </a>
        )
    );
};

export default props => <ServiceListItem {...props} />
